import { MY_HR_CREATE_CHANGE_REQUEST } from "my-hr/graphql";
import * as Yup from "yup";

export const genderDialogDef = {
  type: "gender",
  dialogLabel: "MY_HR_EDIT_GENDER",
  mutation: MY_HR_CREATE_CHANGE_REQUEST,
  items: [
    {
      label: "OC_VALIDITY",
      name: "validFrom",
      type: "datePicker",
      validation: Yup.date().required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_GENDER",
      name: "gender",
      type: "gender",
      dataField: "gender",
      //validation: Yup.string(),
    },
    {
      label: "OC_MESSAGE",
      name: "initialMessage",
      type: "textarea",
      validation: Yup.string(),
    },
  ],
};
